import React from "react";
import { Alert, Button, Stack, Typography } from "@mui/material";

const ProfileReviewQueueStatus = ({
  state,
  scoped,
  totalPending,
  onViewAll,
  onRetry,
}) => (
  <Stack spacing={1}>
    {state.status === "loading" ? (
      <Typography role="status">Checking review items…</Typography>
    ) : null}
    {state.status === "failed" ? (
      <Alert
        severity="warning"
        action={<Button onClick={onRetry}>Try again</Button>}
      >
        We couldn't load the review queue. Your items have not been marked
        complete.
      </Alert>
    ) : null}
    {state.status === "scoped_empty" ? (
      <Typography>
        {totalPending
          ? "Other updates still need your review."
          : "No pending items were found for this update."}
      </Typography>
    ) : null}
    {state.status === "complete" ? (
      <Typography>No items are waiting for review.</Typography>
    ) : null}
    {scoped && !["loading", "failed"].includes(state.status) ? (
      <Button onClick={onViewAll}>
        {totalPending
          ? `View all ${totalPending} pending item${totalPending === 1 ? "" : "s"}`
          : "View full review queue"}
      </Button>
    ) : null}
  </Stack>
);
export default ProfileReviewQueueStatus;
